import React, { forwardRef, useMemo } from 'react'
import { createMagazineRenderConfig, type MagazineRenderSurface } from './magazineRenderConfig'

type Props = {
  surface: MagazineRenderSurface
  html: string
  className?: string
  style?: React.CSSProperties
  id?: string
  ['data-section']?: boolean
}

const MagazineHtml = forwardRef<HTMLDivElement, Props>(function MagazineHtml(
  { surface, html, className, style, id, 'data-section': dataSection },
  ref
) {
  const config = useMemo(() => createMagazineRenderConfig(surface), [surface])
  const safeHtml = useMemo(() => config.prepareHtml(html), [config, html])

  return (
    <div
      ref={ref}
      id={id}
      data-section={dataSection}
      className={[config.className, className || ''].join(' ').trim()}
      style={style}
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  )
})

export default MagazineHtml
